import { APP_CSV_UPLOAD_TYPES } from './app/upload-types'
import { CORE_CSV_UPLOAD_TYPES } from './core/upload-types'

export const UPLOAD_SCOPES = ['core', 'app'] as const
export type UploadScope = (typeof UPLOAD_SCOPES)[number]

export const UPLOAD_SCOPE_LABELS = {
  core: 'Core',
  app: 'App',
} as const
export type UploadScopeLabel = (typeof UPLOAD_SCOPE_LABELS)[keyof typeof UPLOAD_SCOPE_LABELS]

export const CSV_UPLOAD_TYPES = [...CORE_CSV_UPLOAD_TYPES, ...APP_CSV_UPLOAD_TYPES] as const
export type CsvUploadType = (typeof CSV_UPLOAD_TYPES)[number]

export const UPLOAD_REPORT_STATUS = {
  NOT_STARTED: 'NOT_STARTED',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
} as const

export type UploadReportStatus = (typeof UPLOAD_REPORT_STATUS)[keyof typeof UPLOAD_REPORT_STATUS]

interface UploadMetadataMap extends Partial<Record<CsvUploadType, Record<string, string>>> {
  'import-product-type-details': {
    'product-type-id': string
    'file-delimiter'?: string
  }
  'import-agreement-details': {
    'file-delimiter'?: string
  }
  'import-rap-forecasts-details': {
    'rap-forecast-id': string
    'file-delimiter'?: string
  }
  'import-budget-allocations-details': {
    'file-delimiter'?: string
  }
  'import-ip-accruals-details': {
    'ip-accrual-id': string
    'file-delimiter'?: string
  }
  'import-calculation-run-accruals-details': {
    'calculation-run-accrual-id': string
    'file-delimiter'?: string
  }
  'import-channel-mix-details': {
    'channel-mix-id': string
    // Azure imports only: 'true' when the import created the period's mix (a cancel then deletes it).
    'channel-mix-created'?: string
    'file-delimiter'?: string
  }
  'import-distribution-margin-mix-details': {
    'distribution-margin-mix-id': string
    'file-delimiter'?: string
  }
  'import-key-account-contract-estimates': {
    'crt-period': string
    'file-delimiter'?: string
  }
}
export type UploadMetadata<T extends string> = T extends keyof UploadMetadataMap
  ? UploadMetadataMap[T]
  : Record<string, string>
